"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 1c2.136 0 4.145.832 5.657 2.343A7.949 7.949 0 0123 9a7.947 7.947 0 01-2.343 5.657l-.172.172-1.414-1.415.172-.171A5.96 5.96 0 0021 9a5.96 5.96 0 00-1.757-4.243A5.965 5.965 0 0015 3a5.963 5.963 0 00-5.441 3.486 1.002 1.002 0 01-1.038.571L8.39 7.04c-1.16-.16-2.37.282-3.218 1.13A3.972 3.972 0 004 11c0 .911.318 1.765.875 2.468l-1.43 1.43A5.951 5.951 0 012 11a5.96 5.96 0 011.758-4.243A5.896 5.896 0 018.078 5 7.953 7.953 0 0115 1zM5.55 17.036l5.744-5.743h1.413l5.657 5.657-1.414 1.414-3.95-3.95V24h-2v-9.586L6.966 18.45 5.55 17.036z" }), "Upload");
//# sourceMappingURL=Upload.js.map